/**
 * * Модель уровня сложности
 */
export class DifficultyModel {
  /**ID уровня сложности */
  Id!: string;
  /**Название */
  Name!: string;
  /**Цвет */
  Color!: string;
  /**Дефолтная сложность */
  IsDefault: boolean = false;

  constructor(obj?: Partial<DifficultyModel>) {
    Object.assign(this, obj);
  }
}
